import { render, staticRenderFns } from "./AuroraWelcome.vue?vue&type=template&id=40be9164"
import script from "./AuroraWelcome.vue?vue&type=script&lang=js"
export * from "./AuroraWelcome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports